import axios from 'axios'; //only for uploads as of December 31st, 2021
import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    Link,
    // withRouter,
    useLocation,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { artistReviewsHost } from '../../actions/artist';
import { NOTIFICATION_DIALOG_DELAY_MS } from '../../utils/notificationDeepLink';
import {
    TextField,
    //Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputAdornment,
    Grid,
    Box,
    Typography,
    Rating,
    Dialog,
    DialogContent,
    MobileStepper,
} from '@mui/material';
// import { PhoneInput as ReactPhoneInput } from 'react-phone-input-2';
import { styled } from '@mui/material/styles';
import Button from '../layout/SvgButton';

import HostProfile from '../hosts/HostProfile';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import FlareTwoToneIcon from '@mui/icons-material/FlareTwoTone';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useTransition, animated, config } from '@react-spring/web';
import '../../formCards.css';

import { toTitleCase, StackDateforDisplay } from '../../actions/app';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

//filter() for Objects -- https://stackoverflow.com/a/37616104/3338608
Object.filter = (obj, predicate) =>
    Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), []);

const UploadInput = styled('input')({
    display: 'none',
});

const ArtistReviewsHost = ({
    artistMe,
    history,
    auth,
    theEvent,
    artistReviewsHost,
    onNotificationDialogClose,
}) => {
    const loading = false; //a bunch of things are dependent on it; I should really just take it out.
    // const dispatch = useDispatch();

    const [theReview, setTheReview] = useState({});
    const [theOffer, setTheOffer] = useState({});
    const [theHost, setTheHost] = useState({});

    useEffect(() => {
        if (theEvent && theEvent._id) {
            const theAcceptedOffer = theEvent.offersFromHosts.filter(
                (thisOffer) => {
                    // console.log('thisOffer.status', thisOffer.status);
                    if (thisOffer.status === 'ACCEPTED') {
                        return thisOffer;
                    } else return thisOffer;
                }
            )[0];
            // console.log('theAcceptedOffer', theAcceptedOffer);
            setTheOffer(theAcceptedOffer);
        }
        if (theEvent.artistReviewOfHost) {
            setTheReview(theEvent.artistReviewOfHost);
        }
    }, [theEvent]);
    useEffect(() => {
        if (theEvent.artistReviewOfHost) {
            setTheReview(theEvent.artistReviewOfHost);
        }
    }, [theEvent.artistReviewOfHost]);

    useEffect(() => {
        if (theOffer && theOffer.host) {
            setTheHost(theOffer.host);

            // console.log('the ACCEPTED Offer theOffer.host', theOffer.host);
        }

        // console.log('the ACCEPTED Offer', theOffer);
        // console.log('the ACCEPTED Offer Host', theHost);
    }, [theOffer]);

    const [formData, setFormData] = useState({
        eventId: '',
        artistId: '',
        hostId: '',
        bookingWhen: '',
        bookingWhere: {},

        communication: 0,
        promotion: 0,
        tipsDonations: 0,
        merchSales: 0,
        ticketSales: 0,
        revenueExpectations: '',
        attendanceExpectations: '',
        audienceQuality: '',
        venueQuality: 0,
        everythingNeeded: 0,
        introductionByHost: 0,
        hostExample: 0,
        hostInteractions: 0,
        hostAccommodations: 0,
        hostCommitment: 0,
        // recHostForRetreat: '',
        artistNotes: '',
        //New fields - 2026
        hostRating: 0,
        hostFeedback: '',
        testimonial: '',
        hostCritique: '',
        otherArtistFeedback: '',
        otherArtistFeedbackPrivacy: '',
        porchlightRating: 0,
        porchlightFeedback: '',
        porchlightTestimonial: '',
        totalTakeHome: '',
        audienceSize: '',
    });

    useEffect(() => {
        if (theEvent._id && theReview) {
            setFormData({
                eventId: loading || !theEvent._id ? '' : theEvent._id,
                artistId: loading || !artistMe._id ? '' : artistMe._id,
                hostId:
                    loading ||
                    !theOffer.host ||
                    (theOffer.host && !theOffer.host._id)
                        ? ''
                        : theOffer.host._id,
                bookingWhen:
                    loading || !theEvent.bookingWhen
                        ? ''
                        : theEvent.bookingWhen,
                bookingWhere:
                    loading || !theEvent.bookingWhere
                        ? {}
                        : theEvent.bookingWhere,

                communication:
                    loading || !theReview.communication
                        ? 0
                        : theReview.communication,
                promotion:
                    loading || !theReview.promotion ? 0 : theReview.promotion,
                tipsDonations:
                    loading || !theReview.tipsDonations
                        ? 0
                        : theReview.tipsDonations,
                merchSales:
                    loading || !theReview.merchSales ? 0 : theReview.merchSales,
                ticketSales:
                    loading || !theReview.ticketSales
                        ? 0
                        : theReview.ticketSales,
                revenueExpectations:
                    loading || !theReview.revenueExpectations
                        ? ''
                        : theReview.revenueExpectations,
                attendanceExpectations:
                    loading || !theReview.attendanceExpectations
                        ? ''
                        : theReview.attendanceExpectations,
                audienceQuality:
                    loading || !theReview.audienceQuality
                        ? ''
                        : theReview.audienceQuality,
                venueQuality:
                    loading || !theReview.venueQuality
                        ? 0
                        : theReview.venueQuality,
                everythingNeeded:
                    loading || !theReview.everythingNeeded
                        ? 0
                        : theReview.everythingNeeded,
                introductionByHost:
                    loading || !theReview.introductionByHost
                        ? 0
                        : theReview.introductionByHost,
                hostExample:
                    loading || !theReview.hostExample
                        ? 0
                        : theReview.hostExample,
                hostInteractions:
                    loading || !theReview.hostInteractions
                        ? 0
                        : theReview.hostInteractions,
                hostAccommodations:
                    loading || !theReview.hostAccommodations
                        ? 0
                        : theReview.hostAccommodations,
                hostCommitment:
                    loading || !theReview.hostCommitment
                        ? 0
                        : theReview.hostCommitment,
                // recHostForRetreat:
                //     loading || !theReview.recHostForRetreat
                //         ? ''
                //         : theReview.recHostForRetreat,
                artistNotes:
                    loading || !theReview.artistNotes
                        ? ''
                        : theReview.artistNotes,

                //New fields - 2026
                hostRating:
                    loading || !theReview.hostRating ? 0 : theReview.hostRating,
                hostFeedback:
                    loading || !theReview.hostFeedback
                        ? ''
                        : theReview.hostFeedback,
                testimonial:
                    loading || !theReview.testimonial
                        ? ''
                        : theReview.testimonial,
                hostCritique:
                    loading || !theReview.hostCritique
                        ? ''
                        : theReview.hostCritique,

                otherArtistFeedback:
                    loading || !theReview.otherArtistFeedback
                        ? ''
                        : theReview.otherArtistFeedback,
                // otherArtistFeedbackPrivacy:
                //     loading || !theReview.otherArtistFeedbackPrivacy
                //         ? ''
                //         : theReview.otherArtistFeedbackPrivacy,
                porchlightRating:
                    loading || !theReview.porchlightRating
                        ? 0
                        : theReview.porchlightRating,
                porchlightFeedback:
                    loading || !theReview.porchlightFeedback
                        ? ''
                        : theReview.porchlightFeedback,
                porchlightTestimonial:
                    loading || !theReview.porchlightTestimonial
                        ? ''
                        : theReview.porchlightTestimonial,
                totalTakeHome:
                    loading || !theReview.totalTakeHome
                        ? ''
                        : theReview.totalTakeHome,
                audienceSize:
                    loading || !theReview.audienceSize
                        ? ''
                        : theReview.audienceSize,
            });
        } else if (theEvent._id) {
            setFormData({
                eventId: loading || !theEvent._id ? '' : theEvent._id,
                artistId: loading || !artistMe._id ? '' : artistMe._id,
                hostId:
                    loading ||
                    !theOffer.host ||
                    (theOffer.host && !theOffer.host._id)
                        ? ''
                        : theOffer.host._id,
                bookingWhen:
                    loading || !theEvent.bookingWhen
                        ? ''
                        : theEvent.bookingWhen,
                bookingWhere:
                    loading || !theEvent.bookingWhere
                        ? {}
                        : theEvent.bookingWhere,
            });
        }
    }, [auth.loading, artistMe, theEvent, theOffer, theReview]);

    const {
        communication,
        promotion,
        tipsDonations,
        merchSales,
        ticketSales,
        revenueExpectations,
        attendanceExpectations,
        audienceQuality,
        venueQuality,
        everythingNeeded,
        introductionByHost,
        hostExample,
        hostInteractions,
        hostAccommodations,
        hostCommitment,
        // recHostForRetreat,
        artistNotes,
        hostRating,
        hostFeedback,
        testimonial,
        hostCritique,
        otherArtistFeedback,
        porchlightRating,
        porchlightFeedback,
        porchlightTestimonial,
        totalTakeHome,
        audienceSize,
    } = formData;

    const onChange = (e) => {
        //console.log(e);
        //console.log(Object.keys(formGroups).length);
        changesMade.current = true;
        let targetValue = e.target.value;
        switch (e.target.type) {
            case 'checkbox':
                targetValue = e.target.checked;
                break;
            default:
                targetValue = e.target.value;
        }
        const targetName = e.target.name.split('.');
        //console.log(targetName + ': ' + targetValue);
        //setFormData({ ...formData, [e.target.name]: targetValue });
        if (targetName.length === 1) {
            setFormData({ ...formData, [targetName[0]]: targetValue });
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [targetName[0]]: {
                    ...prevData[targetName[0]],
                    [targetName[1]]: targetValue,
                },
            }));
            //console.log(formData);
        }
    };

    //const [changesMade, setChangesMade] = useState(false);
    const changesMade = useRef(false);
    const firstLoad = useRef(true);

    const onSubmit = (e) => {
        e.preventDefault();
        //console.log('Submitting...');
        artistReviewsHost(formData, history, true);
        changesMade.current = false;
    };

    const formGroups = {
        hostRating: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theHost.profileImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    How was your overall experience with{' '}
                    {theHost.firstName + ' ' + theHost.lastName}?
                </FormLabel>,
                // <FormLabel
                //     component="small"
                //     sx={{ textAlign: 'center', display: 'block' }}
                // >
                //     (1 is terrible, 5 is great!)
                // </FormLabel>,
            ],
            [
                <FormControl component="fieldset">
                    <Rating
                        size="large"
                        id="hostRating"
                        value={hostRating}
                        name="hostRating"
                        onChange={(e) => onChange(e)}
                    />
                </FormControl>,
            ],
        ],
        hostFeedback: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theHost.profileImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    INTERNAL USE ONLY: Tell us a bit more about your time with{' '}
                    {theHost.firstName}, including both highlights and
                    challenges.
                </FormLabel>,
                <FormLabel component="small">
                    <em>
                        For instance, did they make you feel welcome, introduce
                        you to stage well, promote the show, model to others in
                        the audience how they should be attentively listening,
                        etc.
                    </em>
                    ?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="hostFeedback_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="hostFeedback"
                        id="hostFeedback"
                        // // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={hostFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        testimonial: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theHost.profileImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    TESTIMONIAL TO SHARE: What would you like others to know
                    about this host or this particular gathering?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="testimonial_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="testimonial"
                        id="testimonial"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={testimonial}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        hostCritique: [
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '80%' }}
                    className="hostCritique_header"
                    justifyContent={'center'}
                >
                    <FormLabel component="legend" sx={{ textAlign: 'center' }}>
                        FOR HOST: Was there anything about the show, venue, or
                        host interactions you think could have been improved?
                    </FormLabel>
                    <FormLabel component="small" sx={{ textAlign: 'center' }}>
                        Be as long or short as you would like; the more specific
                        your feedback, the more helpful!
                    </FormLabel>
                </Grid>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="hostCritique_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="hostCritique"
                        id="hostCritique"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={hostCritique}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        otherArtistFeedback: [
            [
                <FormLabel component="legend">
                    If there was another artist part of this event, please list
                    their name here and any feedback you'd like to share.
                </FormLabel>,
                <FormLabel component="small" sx={{ textAlign: 'center' }}>
                    Please indicate whether this feedback is intended for
                    internal review or external testimonial.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="otherArtistFeedback_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="otherArtistFeedback"
                        id="otherArtistFeedback"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={otherArtistFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        porchlightRating: [
            [
                <FormLabel component="legend">
                    How was your overall experience with Porchlight?
                </FormLabel>,
            ],
            [
                <FormControl component="fieldset">
                    <Rating
                        size="large"
                        id="porchlightRating"
                        value={porchlightRating}
                        name="porchlightRating"
                        onChange={(e) => onChange(e)}
                    />
                </FormControl>,
            ],
        ],

        porchlightFeedback: [
            [
                <FormLabel component="legend">
                    INTERNAL USE ONLY: Tell us a bit more about your experience
                    with Porchlight, including both highlights and challenges.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="porchlightFeedback_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="porchlightFeedback"
                        id="porchlightFeedback"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={porchlightFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        porchlightTestimonial: [
            [
                <FormLabel component="legend">
                    TESTIMONIAL TO SHARE: What would you like others to know
                    about this network?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="porchlightTestimonial_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="porchlightTestimonial"
                        id="porchlightTestimonial"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={porchlightTestimonial}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        totalTakeHome: [
            [
                <FormLabel component="legend">Financials Breakdown</FormLabel>,
                <FormLabel component="small" sx={{ textAlign: 'center' }}>
                    (Note: We only ask these questions because they help our
                    nonprofit (Renew the Arts) demonstrate the financial
                    partnership cultivated through Porchlight to support artists
                    throughout the year.)
                </FormLabel>,
            ],
            [
                [
                    <FormLabel component="legend">
                        How much overall did you take home?
                    </FormLabel>,
                    <FormControl component="fieldset">
                        <TextField
                            variant="standard"
                            name="totalTakeHome"
                            id="totalTakeHome"
                            value={totalTakeHome}
                            onChange={(e) => onChange(e)}
                            type="number"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>,
                ],
                [
                    <FormLabel component="legend">
                        How much of this total was in merch sales?
                    </FormLabel>,
                    <FormControl component="fieldset">
                        <TextField
                            variant="standard"
                            name="merchSales"
                            id="merchSales"
                            value={merchSales}
                            onChange={(e) => onChange(e)}
                            type="number"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </FormControl>,
                ],
                [
                    <FormLabel component="legend">
                        Did this revenue live up to your expectations?
                    </FormLabel>,
                    <FormControl component="fieldset">
                        <RadioGroup
                            id="revenueExpectations"
                            value={revenueExpectations}
                            name="revenueExpectations"
                            onChange={(e) => onChange(e)}
                        >
                            <FormControlLabel
                                value="fellShort"
                                control={<Radio />}
                                label={`No, this revenue fell short of my expectations`}
                            />
                            <FormControlLabel
                                value="met"
                                control={<Radio />}
                                label="Yes, this revenue met my expectations."
                            />
                            <FormControlLabel
                                value="exceeded"
                                control={<Radio />}
                                label="Did it ever?! This revenue exceeded my expectations!"
                            />
                        </RadioGroup>
                    </FormControl>,
                ],
            ],
        ],

        audienceSize: [
            [
                <FormLabel component="legend">
                    How many attendees would you guess were there? How would you
                    summarize their quality as an audience?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="audienceSize_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="audienceSize"
                        id="audienceSize"
                        // label={'Notes'}
                        placeholder={'Type your response here'}
                        value={audienceSize}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        endSlide: [
            [
                <Typography
                    component="h2"
                    sx={{ fontSize: '2.2em!important', textAlign: 'center' }}
                >
                    Thanks so much!
                </Typography>,
                <Typography
                    component="h2"
                    sx={{ fontSize: '2.2em!important', textAlign: 'center' }}
                >
                    It helps more than you know...
                </Typography>,
                <>
                    <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                            textWrap: 'balance',
                        }}
                    >
                        The Porchlight community is constantly growing and
                        learning, and your insight is essential as we develop a
                        network of hosts who exemplify the heart of Jesus as we
                        all care for attendees, artists, and culture.
                    </Typography>

                    <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                        }}
                    >
                        Your collaboration and perspective is an essential part
                        of this process.
                    </Typography>
                    <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                        }}
                    >
                        Thank you.
                    </Typography>

                    <Grid
                        item
                        container
                        justifyContent="center"
                        sx={{ marginTop: '16px' }}
                    >
                        <Button
                            btnwidth="300"
                            onClick={() => {
                                setDialogOpen(false);
                                if (
                                    typeof onNotificationDialogClose ===
                                    'function'
                                ) {
                                    onNotificationDialogClose();
                                }
                            }}
                        >
                            Close This Window
                        </Button>
                    </Grid>
                </>,
            ],
        ],
    };

    let query = useQuery();
    const queryEditField = query.get('field');
    const queryEventID = query.get('eventID');
    const queryOpen = query.get('open');
    const location = useLocation();
    let formStartIndex = 0;

    if (queryEditField) {
        const formGroupKeys = Object.keys(formGroups);
        formStartIndex =
            formGroupKeys.indexOf(queryEditField) > -1
                ? formGroupKeys.indexOf(queryEditField)
                : 0;
    }

    //// CARD INDEX ///////
    const [formCardIndex, setIndex] = useState(formStartIndex);

    const cardIndex = formCardIndex;

    const [formCardDirection, setDirection] = useState(1);
    const transitions = useTransition(formCardIndex, {
        key: formCardIndex,
        initial: null,
        from: {
            opacity: 0,
            transform: `translateX(${formCardDirection * 60}vw)`,
        },
        enter: { opacity: 1, transform: 'translateX(0%)' },
        leave: {
            opacity: 0,
            transform: `translateX(${formCardDirection * -60}vw)`,
        },
        // config: config.molasses,
        config: { mass: 2, tension: 280, friction: 60 },
        // onRest: (_a, _b, item) => {
        //   if (formCardIndex === item) {
        //     set(cardIndex => (cardIndex + 1) % formGroups.length)
        //   }
        // },
        exitBeforeEnter: false,
    });
    const nextCard = (e) => {
        setDirection(1);
        if (changesMade.current) {
            onSubmit(e);
        }
        setIndex((cardIndex) => {
            //(cardIndex + 1) % Object.keys(formGroups).length;
            if (cardIndex === Object.keys(formGroups).length - 1) {
                //if it's at the end there's nothing next, don't loop around
                return cardIndex;
            } else {
                return cardIndex + 1;
            }
        });
    };
    const previousCard = (e) => {
        setDirection(-1);
        if (changesMade.current) {
            onSubmit(e);
        }
        setIndex((cardIndex) => {
            // if (cardIndex == 0) { //loop around to the last index
            //     cardIndex = Object.keys(formGroups).length;
            // }
            if (cardIndex == 0) {
                //if it's at the benninging there's nothing previous, don't loop around
                return cardIndex;
            } else {
                return cardIndex - 1;
            }
        });
    };

    //Dialog Functions
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleReviewDialogClose = () => {
        setDialogOpen(false);
        if (typeof onNotificationDialogClose === 'function') {
            onNotificationDialogClose();
        }
    };

    useEffect(() => {
        if (queryOpen !== 'survey') return;
        if (!theEvent || !queryEventID || String(theEvent._id) !== String(queryEventID)) {
            return;
        }
        const timer = setTimeout(
            () => setDialogOpen(true),
            NOTIFICATION_DIALOG_DELAY_MS
        );
        return () => clearTimeout(timer);
    }, [queryOpen, queryEventID, theEvent._id, location.key]);

    return (
        <Fragment key={`Fragment` + theEvent._id + artistMe._id}>
            <Dialog
                open={dialogOpen}
                onClose={handleReviewDialogClose}
                scroll="body"
                fullWidth
                maxWidth="lg"
                className="porchlightBG"
            >
                <MobileStepper
                    variant="progress"
                    steps={Object.keys(formGroups).length || cardIndex.length}
                    position="static"
                    activeStep={cardIndex}
                    sx={{
                        // width: '100cqw',
                        position: 'absolute',
                        top: 0,
                        padding: '0px',
                        left: 0,
                        right: 0,
                        width: '100%',
                        // backgroundColor: 'var(--link-color)',
                        '& .MuiLinearProgress-root': {
                            // width: { xs: '100%', sm: '50%' },
                            width: '100%',
                        },
                    }}
                    backButton={undefined}
                    nextButton={undefined}
                    LinearProgressProps={{ color: 'primary' }}
                />
                <DialogContent
                    sx={
                        {
                            // margin: '8px',
                            // border: '1px solid var(--primary-color)',
                        }
                    }
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            backgroundColor: 'rgba(0 0 0 /.6)',
                            padding: '0',
                        }}
                    >
                        <StackDateforDisplay
                            date={theEvent.bookingWhen}
                        ></StackDateforDisplay>
                    </Box>
                    <form className="form" onSubmit={(e) => onSubmit(e)}>
                        <Grid
                            container
                            direction="row"
                            alignItems="start"
                            justifyContent="center"
                            height="65vh"
                            sx={{ padding: '20px!important' }}
                            key={`cardGrid` + theEvent._id + artistMe._id}
                        >
                            <Grid
                                container
                                item
                                sx={{ width: '100%' }}
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                className="cardNav"
                            >
                                <Grid item>
                                    {/* { cardIndex > 0 ? (  */}
                                    <Button
                                        variant="contained"
                                        component="span"
                                        onClick={(e) => previousCard(e)}
                                        sx={{
                                            opacity: cardIndex > 0 ? 1 : 0.2,
                                            transition:
                                                'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 500ms',
                                        }}
                                    >
                                        <ArrowBackIcon></ArrowBackIcon>Previous
                                    </Button>
                                    {/* ) : '' } */}
                                </Grid>
                                {/* <Grid item>
                            <label htmlFor="submit">
                                <input id="submit" type="submit" hidden />
                                <Button
                                    variant="contained"
                                    component="span"
                                    onClick={(e) => onSubmit(e)}
                                >
                                    Save <SaveTwoToneIcon></SaveTwoToneIcon>
                                </Button>
                            </label>
                        </Grid> */}
                                <Grid item>
                                    {/* { cardIndex < formGroups.length - 1 ? ( */}
                                    <Button
                                        variant="contained"
                                        component="span"
                                        onClick={(e) => nextCard(e)}
                                        sx={{
                                            opacity:
                                                cardIndex !==
                                                Object.keys(formGroups).length -
                                                    1
                                                    ? 1
                                                    : 0.2,
                                            transition:
                                                'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 500ms',
                                        }}
                                    >
                                        Next
                                        <ArrowForwardIcon></ArrowForwardIcon>
                                    </Button>
                                    {/* ) : ''} */}
                                </Grid>
                            </Grid>
                        </Grid>
                        {transitions((style, i) => (
                            <animated.div
                                className={'animatedFormGroup'}
                                key={'animatedFormGroup' + i}
                                style={{
                                    ...style,
                                    minHeight: 'inherit',
                                }}
                            >
                                <div
                                    className="form-group"
                                    key={'form-group' + i}
                                    style={{ maxWidth: '100%' }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        alignItems="center"
                                        //spacing={2}
                                        sx={{
                                            width: '100%',
                                            margin: '0 auto',
                                        }}
                                        key={
                                            `bookingDetails` + theEvent._id + i
                                        }
                                        //className="bookingDetails"
                                    >
                                        {/* <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}> */}

                                        {/* {formGroups && formGroups.length > 0 ? formGroups[i].map((formGroup, ind) => (  */}
                                        <Grid
                                            item
                                            size={{ xs: 12 }}
                                            sx={{ '--form-num': `'${i + 1}'` }}
                                            data-form-num={i + 1}
                                            className="formInquiry"
                                        >
                                            {
                                                formGroups[
                                                    Object.keys(formGroups)[i]
                                                ][0]
                                            }
                                        </Grid>
                                        {
                                            formGroups[
                                                Object.keys(formGroups)[i]
                                            ][1]
                                        }
                                    </Grid>
                                </div>
                            </animated.div>
                        ))}
                    </form>
                </DialogContent>
            </Dialog>
            {(!theEvent.artistReviewOfHost ||
                !theEvent.artistReviewOfHost._id) && (
                <Box
                    className="createdAt"
                    sx={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                    }}
                >
                    {' '}
                    <Typography
                        component="p"
                        sx={{
                            fontSize: '.7em',
                            fontFamily: 'var(--secondary-font)',
                            color: 'var(--link-color)',
                        }}
                    >
                        <FlareTwoToneIcon
                            style={{ fontSize: '1.5em' }}
                        ></FlareTwoToneIcon>{' '}
                        Please consider reviewing your experience with{' '}
                        {theHost.firstName} {theHost.lastName}.
                        {/* Created On: {prettifyDate(thisEvent.createdAt) */}
                    </Typography>
                </Box>
            )}
            <Grid item style={{ margin: '20px auto 0', alignSelf: 'center' }}>
                <Button btnwidth="250" onClick={() => setDialogOpen(true)}>
                    {theEvent.artistReviewOfHost &&
                    theEvent.artistReviewOfHost._id
                        ? 'Edit Your Review'
                        : 'Review Your Experience'}
                </Button>
            </Grid>
        </Fragment>
    );
};

ArtistReviewsHost.propTypes = {
    artistMe: PropTypes.object.isRequired,
    theEvent: PropTypes.object,
    auth: PropTypes.object.isRequired,
    artistReviewsHost: PropTypes.func.isRequired,
    onNotificationDialogClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    artistMe: state.artist.me,
});

export default connect(mapStateToProps, {
    artistReviewsHost,
    // })(withRouter(ArtistReviewsHost)); //withRouter allows us to pass history objects
})(ArtistReviewsHost);
